/**
 * @flow
 */
import styled from 'react-emotion'

import { mobile } from '../../../../utils/mixins'
import {
  Typo20WhiteFourDD,
  Typo16GainsBoroDD
} from '../../../../themes/Fonts/Din2014'
import Colors from '../../../../themes/Colors'
import CloudinaryS3LazyLoadedImage from '../../../CloudinaryS3LazyLoadedImage'

export const MainContainer = styled('div')`
  display: flex;
  flex-direction: column;
  align-items: center;
  ${mobile} {
    margin-bottom: 30px;
    &:last-child {
      margin-bottom: 0px;
    }
  }
`

export const ProfilesImage = styled(CloudinaryS3LazyLoadedImage)`
  height: 190px;
  width: 190px;
  border-radius: 50%;
`

export const NameText = styled(Typo20WhiteFourDD)`
  color: ${Colors.charcoalGreyTwo};
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  margin-top: 0.9375em;
`
export const Designation = styled(Typo16GainsBoroDD)`
  color: ${Colors.charcoalGreyTwo};
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/components/TeamNew/AdvisoryCouncilSection/CouncilMember/styledComponents.js